import { render } from "./ShiftAdd.vue?vue&type=template&id=8f2402d4&scoped=true"
import script from "./ShiftAdd.vue?vue&type=script&lang=js"
export * from "./ShiftAdd.vue?vue&type=script&lang=js"

import "./ShiftAdd.vue?vue&type=style&index=0&id=8f2402d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f2402d4"]])

export default __exports__